$(document).ready(function() {
  
  // Initialize the location modal
  $('#locationModal').modal({
    dismissible: true,
    opacity: 0.5,
    endingTop: '-40%',
    complete: function() {
      sessionStorage.setItem('locationCheck', 'checked');   
    }
  });

  function checkLocation() {
    if (sessionStorage.getItem('locationCheck')) {
      return;
    } else {
      var access_key = '08f4769a2da7dfa02f5edfbb1537a2ef';
      $.ajax({
        url: 'https://api.ipstack.com/check?access_key=' + access_key,
        dataType: 'jsonp',
        success: function(json){
          if (json.country_code != 'CA') {
            $('#locationModal').modal('open');
          }
        }
      });
    }
  }
  checkLocation();
  
  // Flag Dropdown
  $(".site-header__flag-dropdown").dropdown({
    inDuration: 300,
    outDuration: 225,
    constrainWidth: false, // Does not change width of dropdown to that of the activator
    hover: true, // Activate on hover
    gutter: 0, // Spacing from edge
    belowOrigin: true, // Displays dropdown below the button
    alignment: "left", // Displays dropdown with edge aligned to the left of button
    stopPropagation: false // Stops event propagation
  });
    
  // Product Page Tabs
  $(".materialize-tabs__container ul.tabs").tabs();
  
  // Re-execute tab initialization when making changes in the theme editor
  $(document).on("shopify:section:load", function(){
    $(".materialize-tabs__container ul.tabs").tabs();
  });

  // Product Page Buy Button at bottom of page
  $("#buyButton").click(function(evt){
    evt.preventDefault();
    $(".product-form").submit();
  });

});
